// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"421":"ddc0ea03","466":"c1398ee5","767":"3ff4e8e9","924":"e705ce48"}[chunkId] + ".css";
};